import styled from 'styled-components';
import { SEARCH_IFRAME_OFFSET_BOTTOM, SEARCH_IFRAME_OFFSET_TOP } from '../constants';
export const StyledIframeWrapper = styled.div.withConfig({
  displayName: "StyledIframeWrapper",
  componentId: "sc-1s78vrt-0"
})(["display:flex;flex-direction:column;position:relative;min-height:min( 355px,calc( 100vh - ", "px - ", "px ) );max-height:calc( 100vh - ", "px - ", "px );overflow:hidden;height:auto;opacity:", ";transition:opacity 0.1s ease-in !important;> iframe{min-width:100%;max-width:100%;max-height:100%;flex-grow:1;}"], SEARCH_IFRAME_OFFSET_TOP, SEARCH_IFRAME_OFFSET_BOTTOM, SEARCH_IFRAME_OFFSET_TOP, SEARCH_IFRAME_OFFSET_BOTTOM, ({
  isOpen
}) => isOpen ? '1' : '0');